import React from "react";
import { Navbar, NavbarBrand } from "reactstrap";
import logo from "../assets/FAEPI-logo.png";

const NavBar = () => {
  return (
    <Navbar color="white" expand="md">
      <NavbarBrand href="/" className="mx-auto">
        <img src={logo} alt="Logo" width="150px"></img>
      </NavbarBrand>
    </Navbar>
  );
};

export default NavBar;
